"use strict";

define('view/notifications/instant.notifications',['marionette', 'uikit/mixins/component.mixin', './instant.notification'], function (Mn, ComponentMixin, InstantNotification) {
  var InstantNotifications = Mn.CollectionView.extend(ComponentMixin).extend({
    childView: InstantNotification,
    childViewEventPrefix: 'notification',
    options: {
      limit: 5
    },
    collectionEvents: {
      'add': 'limitNotifications'
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.collection = new Backbone.Collection([], {
        model: InstantNotification.Model
      });
    },
    limitNotifications: function limitNotifications() {
      if (this.collection.length > this.getOption('limit')) {
        this.collection.shift();
      }
    },
    onNotificationClose: function onNotificationClose(e) {
      this.collection.remove(e.model);
    }
  });
  return InstantNotifications;
});

